import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { VueQueryPlugin, QueryClient } from '@tanstack/vue-query'

import App from './App.vue'
import router from './router'
import i18n from './locales'
import ToastContainer from './components/ui/ToastContainer.vue'
// Error boundary component is imported inside App.vue (kept scoped there).
import { useTheme } from './composables/useTheme'
import { useAppearanceStore } from './stores/appearance'
import { useAuthStore } from './stores/auth'
import { unregisterStaleServiceWorkers } from './sw-register'

import './style.css'

// Single shared QueryClient with sensible defaults
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      gcTime: 5 * 60_000,
    },
    mutations: {
      retry: 0,
    },
  },
})

// Pinia must be installed before any store reads persistence.
const pinia = createPinia()

const app = createApp(App)

app.use(pinia)                       // 1. Pinia
app.use(router)                      // 2. Router
app.use(VueQueryPlugin, { queryClient }) // 3. Vue Query
app.use(i18n)                        // 4. i18n

// Bootstrap theme + appearance after pinia is installed so stores can read persistence.
const { initTheme } = useTheme()
initTheme()

// Apply persisted appearance (accent color + density + locale)
const appearance = useAppearanceStore()
appearance.applyAll()

// v3.13.92: 用 cookie 会话恢复 auth.user — 头像/用户名在 401 兜底清空
// localStorage 后能自动回来 (异步, 不阻塞首屏; 守卫已有本地态兜底)。
const authStore = useAuthStore()
void authStore.restoreSession()

// 5. Global toast container
app.component('ToastContainer', ToastContainer)

// 6. ErrorBoundary component is imported inside App.vue (no global registration needed)

// 7. Mount
app.mount('#app')

// 8. Register Service Worker (PWA shell cache + asset cache). Dev mode skipped.
unregisterStaleServiceWorkers()
